import React from 'react'
import { Box, SimpleGrid, GridItem, Heading, Text, Button, Image } from '@chakra-ui/react'
import {Element } from 'react-scroll'
// import { motion, useMotionValue, useTransform } from "framer-motion";

export default function FirstSec() {
    // const x = useMotionValue(200);
    // const y = useMotionValue(200);

    // const rotateX = useTransform(y, [0, 400], [15, -15]);
    // const rotateY = useTransform(x, [0, 400], [-15, 15]);

    // function handleMouse(event:any) {
    //     const rect = event.currentTarget.getBoundingClientRect();

    //     x.set(event.clientX - rect.left);
    //     y.set(event.clientY - rect.top);
    //}
  return (
    <>
       <Box className='frst_sc_main'>
            <Element name="Introdusction">
                    <Box className='upcro_launch_main'>
                        <Box className='width_full'>
                            <SimpleGrid columns={12} columnGap={3} rowGap={2} >
                                <GridItem colSpan={[12, 12, 12, 6]}>
                                    <Box className='launch_text_box'>
                                        <Box className='launch_text_box_inn' data-aos="fade-up" data-aos-delay="1000" data-aos-duration="800">
                                            <Heading as="h3">upCake</Heading>
                                            <Text>
                                            Paired against CAKE; upCAKE is the first ERC-31337 token paired against a native DEX governance token and our second UpToken launched on the Binance Smart Chain.
                                            </Text>
                                            <Box className='launch_btns'>
                                                <Button as="a" href='#' className='glow-on-hover'>BUY NOW</Button>
                                                <Button as="a" href='#' className='entr_a glow-on-hover'>ENTER APP</Button>
                                                <Button as="a" href='#' className='glow-on-hover'>CHART</Button>
                                            </Box>
                                        </Box>
                                    </Box>
                                </GridItem>
                                <GridItem colSpan={[12, 12, 12, 6]}>
                                {/* <motion.div onMouseMove={handleMouse}
                                    style={{
                                        display: "flex",
                                        placeItems: "center",
                                        placeContent: "center",
                                        width: "100%",
                                        perspective: 400,
                                        background: '#050d0f',
                                    }}> */}
                                        <Box className='launch_text_box' data-aos="zoom-in" data-aos-delay="500">
                                    {/* <Box className=''> */}
                                        {/* <motion.div 
                                            className=''
                                            style={{
                                                width: "100%",
                                                rotateX: rotateY,
                                                rotateY: rotateX
                                            }}> */}
                                                <Box className='radial_gradiant_box'>
                                                    <Image src='img/frst_sc_main_nil.png' className='upcro_first_img' />
                                                </Box>
                                        {/* </motion.div> */}
                                    {/* </Box> */}
                                        </Box>
                                {/* </motion.div> */}
                                </GridItem>
                            </SimpleGrid>
                        </Box>
                        
                        
                        
                    </Box>
                </Element>
       </Box>
    </>
  )
}
